export default function () {
  return {
    byId: {}, // { [id]: { item, ts, ctx } }
    inflight: {}, // { [id]: Promise }
    order: [], // LRU order
  };
}
